import React from 'react';
import { Target } from 'lucide-react';
import { missionStatement } from '../data/mock';

const MissionSection = () => {
  return (
    <section id="mission" className="mission-section py-16 lg:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6" style={{ background: 'linear-gradient(135deg, #d9b3d9 0%, #c49bc4 100%)' }}>
            <Target className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl sm:text-4xl font-display font-semibold mb-4" style={{ color: '#c49bc4' }}>
            Our Mission Statement
          </h2>
        </div>
        
        <div className="mission-card">
          <p className="text-lg sm:text-xl leading-relaxed text-gray-700 text-center font-light">
            {missionStatement}
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;